import Api from './Api'

export default {
  toggleView (objectId, report, viewed) {
    return Api().post(`/objekt/report/${objectId}.json`, {
      'Report': report
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/ReportViewService.js